import { MDBAlert, MDBCheckbox, MDBChip, MDBModalFooter, MDBPopconfirm, MDBPopconfirmMessage, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import "../../../../src/App.css";
import PhoneBlue from "../../../../src/components/images/Cell.svg";
import phoneImageActive from "../../../../src/components/images/Ip_Phone_icon.svg";
import appleImage from "../../../../src/components/images/Apple.svg";
import teamsImage from "../../../../src/components/images/teams.svg";
import windowsImage from "../../../../src/components/images/Microsoft.svg";
import androidImage from "../../../../src/components/images/Android.svg";
import iosImage from "../../../../src/components/images/iOS.svg";
import LaptopOrange from "../../../../src/components/images/laptop_orange.svg";
import Location from "../../../../src/components/images/location_red.svg";
import TowerIconBlue from "../../images/TowerIconBlue.png";
import TowerIconRed from "../../images/TowerIconRed.png";
//import { Icon } from "leaflet";
// import datahard from "./random-mark.json"; //sample data to test in dev local network
import L from "leaflet";
import { MDBBtn, MDBIcon, MDBSpinner, MDBTable } from "mdb-react-ui-kit";
import ReactDOM from "react-dom";
import ReactDOMServer from "react-dom/server";
import { getLiveDataRegisteredDevicesInDeviceMap } from "../../../apiclients/streamsapi_bridge";
import PopupLoader from "../../../views/popups/PopupLoader";
import AddDevices from "../../../views/popups/phonesystem/AddDevice";
import TabIDConstant from "../../../apiclients/TabIDConstant";
import ReactCountryFlag from "react-country-flag"
import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";
import UIConstant from "../../../apiclients/UIConstant";

countries.registerLocale(en);

import("leaflet.markercluster/dist/leaflet.markercluster.js");
import("leaflet.markercluster/dist/MarkerCluster.css");
import("leaflet.markercluster/dist/MarkerCluster.Default.css");

function Map() {
  const [data, setData] = useState([]);
  const [fillData, setFillData] = useState([]);
  const [isloading, setIsloading] = useState(false);
  const map = useRef(null);
  const searchRef = useRef(null);
  const devices_rows = useRef(null);
  console.log("Map Component request reached:");
  console.dir(data);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const tableHeaders = ["Name", "Model", "MAC", "IP Address", ""];
  const tableHeadersNew = ["Name", "IP Address", ""];
  const [searchData, setSearchData] = useState([]);
  const [showAddDevicePopup, setShowAddDevicePopup] = useState(false);
  const addDeviceToggle = () => setShowAddDevicePopup(!showAddDevicePopup);


  const [showLocation, setShowLocation] = useState(false);
  const [showProvisioning, setShowProvisioning] = useState(false);
  const [showDeviceTypeModel, setShowDeviceTypeModel] = useState(false);


  const [filterModels, setFilterModels] = useState([]);
  const [provisioningTypes, setProvisioningTypes] = useState([]);
  const [filterSelectedLocations, setFilterSelectedLocations] = useState([]);

  const [locationsList, setLocationsList] = useState();
  const [deviceModelsList, setDeviceModelsList] = useState([]);

  const [selectedLocationchips, setSelectedLocationchips] = useState("");
  const [provisioningTypeChips, setProvisioningTypeChips] = useState("");
  const [selectedModelChip, setSelectedModelChip] = useState("");

  const [constantLocation, setconstantLocation] = useState([]);
  const [constantTypes, setconstantTypes] = useState([]);
  const [constantfilterModels, setconstantfilterModels] = useState([]);
  const [inputValue, setInputValue] = useState("");


  const toggleLocation = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowLocation(!showLocation);
    resetFilters("location");
  };

  const toggleProvisioning = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowProvisioning(!showProvisioning);
    resetFilters("provisioning");
  };

  const toggleDeviceTypeModel = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowDeviceTypeModel(!showDeviceTypeModel);
    resetFilters("deviceTypeModel");
  };

  const resetFilters = (filter) => {
    if (filter !== "location") setShowLocation(false);
    if (filter !== "provisioning") setShowProvisioning(false);
    if (filter !== "deviceTypeModel") setShowDeviceTypeModel(false);

  };

  function handleFilterLocations(filterLocations) {
    try {
      const updatedValues = [...filterSelectedLocations]; // Clone the current state array

      if (updatedValues.includes(filterLocations)) {
        const update = updatedValues.filter((e) => e !== filterLocations);
        setFilterSelectedLocations(update)
        console.log("update :: value..", update)
      }
      else {
        updatedValues.push(filterLocations)
        setFilterSelectedLocations(updatedValues);
      }
      setShowLocation(true);
      // Update the state
      // setconstantLocation(updatedValues);
      //console.log("constant location set:::::::::::::::" + JSON.stringify(constantLocation))
      console.log("Updated filterSelectedLocations: ", JSON.stringify(updatedValues)); // Log the updated array
    } catch (error) {
      console.log("Error in handleprovisioningTypes:", error);
    }
  };
  console.log("locations", filterSelectedLocations)
  function handleProvisioningDevise(value) {
    try {
      console.log("handleProvisioningDevise ::: " + value);
      if (!provisioningTypes.includes(value)) {
        setProvisioningTypes(prev => [...prev, value]);
      } else {
        const values = provisioningTypes.filter((e) => e !== value)
        setProvisioningTypes(values)
      }

      // setconstantTypes(pre => [...pre, value]);
      setShowProvisioning(true);
    } catch (e) {
      console.log("Error in handleProvisioningDevise:", e);
    }
  }
  console.log("provi", provisioningTypes)
  function clearFilterData() {
    setData(fillData);
    setFildataToSearchData(fillData)
    setFilterSelectedLocations([]);
    setFilterModels([]);
    setProvisioningTypes([]);
    setSelectedLocationchips("");
    setSelectedModelChip("");
    setProvisioningTypeChips("");
    setconstantLocation([]);
    setconstantTypes([]);
    setconstantfilterModels([]);
  }

  function selectFilterModel(model) {
    try {
      console.log("model: " + model);
      let updatedValues = [...filterModels]; // Clone the current state array
      if (updatedValues.includes(model)) {
        const values = updatedValues.filter((e) => e !== model) // Add the model
        setFilterModels(values);
      } else {
        updatedValues.push(model);
        setFilterModels(updatedValues);
      }
      setShowDeviceTypeModel(true);

      // setconstantfilterModels(updatedValues);
      console.log("setFilterModels: ", JSON.stringify(updatedValues)); // Log the updated array
    } catch (error) {
      console.log("Error in setFilterModels:", error);
    }
  }
  console.log("models", filterModels);
  function modelsClosePopup() {
    setFilterModels(constantfilterModels);
  }

  const toggleBackClick = (event, value) => {
    if (value == 1) {
      setFilterSelectedLocations([]);
    } if (value == 2) {
      setProvisioningTypes([]);
    } if (value == 3) {
      setFilterModels([]);
    }
    event.preventDefault();
    event.stopPropagation();
    setShowLocation(false);
    setShowProvisioning(false);
    setShowDeviceTypeModel(false);

  };
  function firstClose(e) {
    if (constantLocation.length == 0 || constantTypes.length == 0 || constantfilterModels.length == 0) {
      setFilterSelectedLocations(constantLocation);
      setProvisioningTypes(constantTypes);
      setFilterModels(constantfilterModels);
    }
    setShowLocation(false);
    setShowProvisioning(false);
    setShowDeviceTypeModel(false)
  }
  function cancelFilter(value) {
    console.log("cancelFilter value :: " + value);
    if (value == 1) {
      setFilterSelectedLocations([]);
      setShowLocation(!showLocation);
    } if (value == 2) {
      setProvisioningTypes([]);
      setShowProvisioning(!showProvisioning);
    } if (value == 3) {
      setFilterModels([]);
      setShowDeviceTypeModel(!showDeviceTypeModel);
    }
    if (value == 4) {
      console.log("setFilterSelectedLocations " + filterSelectedLocations, "constantLocation ", constantLocation);
      setFilterSelectedLocations(constantLocation);
      setShowLocation(!showLocation);
    }
    if (value == 5) {
      console.log("provisioningTypes " + provisioningTypes, "constantTypes ", constantTypes);
      setProvisioningTypes(constantTypes);
      setShowProvisioning(!showProvisioning);
    }
  }
  const isArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  };
  function typesClosePopup() {
    setProvisioningTypes(constantTypes);
  }

  const filterLocations = (e, selectedLocations, second) => {
    try {
      console.log("allData", JSON.stringify(fillData));
      if (selectedLocations.length > 0 && second !== 2) {
        const fillLocations = data.filter((e) => selectedLocations.includes(e.geometry.regionName))
        const locationChipData = selectedLocations.map((item, index) => index === 0 ? `Locations : ${item}` : item).join(",")
        setData(fillLocations);
        setFildataToSearchData(fillLocations)
        setconstantLocation(selectedLocations);
        setShowLocation(!showLocation);
        setSelectedLocationchips(locationChipData)
      } else {
        console.log("No locations selected, resetting device list.");
      }
      if (second == 2) {
        let filterData2 = [...fillData]
        if (constantTypes.length > 0 || constantfilterModels.length > 0) {
          filterData2 = filterData2.filter((e) => selectedLocations.includes(e.geometry.regionName))
          if (constantTypes.length > 0) {
            filterData2 = filterData2.filter((e) => constantTypes.includes(e.provisioning_type))
          }
          if (constantfilterModels.length > 0) {
            filterData2 = filterData2.filter((e) => constantfilterModels.includes(e.properties.model))
          }
          const locationChipData = selectedLocations.map((item, index) => index === 0 ? `Locations : ${item}` : item).join(",")
          setSelectedLocationchips(locationChipData)
          setData(filterData2);
          setFildataToSearchData(filterData2)
          setconstantLocation(selectedLocations);
          setShowLocation(!showLocation);
        } else {
          const fillLocations = fillData.filter((e) => selectedLocations.includes(e.geometry.regionName))
          setData(fillLocations);
          setFildataToSearchData(fillLocations)
          setconstantLocation(selectedLocations);
          setShowLocation(!showLocation);
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  console.log("without", fillData)
  console.log("data", data)

  function handleDelete(value, deleteFilterData) {
    console.log("value " + value);
    let filterData = [...fillData];
    if (value === 1 && deleteFilterData.length > 0) {
      setData(fillData);
      setFildataToSearchData(fillData)
      setFilterSelectedLocations([]); // Clear location filters
      setSelectedLocationchips("");
      setconstantLocation([]);

      if (constantfilterModels.length > 0 || constantTypes.length > 0) {
        if (constantfilterModels.length > 0) {
          filterData = filterData.filter((e) => constantfilterModels.includes(e.properties.model));
        }
        if (constantTypes.length > 0) {
          filterData = filterData.filter((e) => constantTypes.includes(e.device_type));
        }
        setData(filterData)
        setFildataToSearchData(filterData)
      } else {
        setData(fillData)
        setFildataToSearchData(fillData)
      }


    }
    else if (value === 2 && deleteFilterData.length > 0) {
      console.log("Removing provisioning type filters: ", JSON.stringify(deleteFilterData));

      if (provisioningTypes.length > 0) {
        setData(fillData);
        setFildataToSearchData(fillData)
        setShowProvisioning(false);
        setProvisioningTypeChips("");
        setProvisioningTypes([]);
        setconstantTypes([])
      }
      if (constantLocation.length > 0 || constantfilterModels.length > 0) {
        if (constantLocation.length > 0) {
          filterData = filterData.filter((e) => constantLocation.includes(e.geometry.regionName));
        }
        if (constantfilterModels.length > 0) {
          filterData = filterData.filter((e) => constantfilterModels.includes(e.properties.model));
        }
        setData(filterData)
        setFildataToSearchData(filterData)
      } else {
        setData(fillData)
        setFildataToSearchData(fillData)
      }
    }
    else if (value == 3 && filterModels.length > 0) {
      setFilterModels([]);
      setSelectedModelChip("");
      setconstantfilterModels([]);
      setData(fillData);
      setFildataToSearchData(fillData)

      if (constantLocation.length > 0 || constantTypes.length > 0) {
        if (constantLocation.length > 0) {
          filterData = filterData.filter((e) => constantLocation.includes(e.geometry.regionName));
        }
        if (constantTypes.length > 0) {
          filterData = filterData.filter((e) => constantTypes.includes(e.device_type));
        }
        setData(filterData)
        setFildataToSearchData(filterData)
      } else {
        setData(fillData)
        setFildataToSearchData(fillData)
      }
    }
    console.log("data ::: ", data)
  }
  function handleProvisioningChange(filterDesignation, second) {
    try {
      console.log("filterDesignation ::: " + JSON.stringify(filterDesignation));
      if (filterDesignation.length > 0) {
        const filterProvi = data?.filter((e) => filterDesignation.includes(e.device_type))
        const proviChipsData = filterDesignation.map((item, index) => (index === 0 ? `Provision : ${item === 2 && "Desktop" || item === 1 && "IP Phones" || item === 3 && "Mobile"}` : item === 2 && "Desktop" || item === 1 && "IP Phones" || item === 3 && "Mobile")).join(",");
        setProvisioningTypeChips(proviChipsData)
        setData(filterProvi);
        setFildataToSearchData(filterProvi)
        setShowProvisioning(!showProvisioning);
        setconstantTypes(filterDesignation)
      }
      if (filterDesignation.length > 0 && second === 2) {
        let filterData = [...fillData]
        if (constantLocation.length > 0 || constantfilterModels.length > 0) {
          filterData = filterData.filter((e) => filterDesignation.includes(e.device_type));
          if (constantLocation.length > 0) {
            filterData = filterData.filter((e) => constantLocation.includes(e.geometry.regionName))
          }
          if (constantfilterModels.length > 0) {
            filterData = filterData.filter((e) => constantfilterModels.includes(e.properties.model))
          }
          setData(filterData)
          setFildataToSearchData(filterData)
          setconstantTypes(filterDesignation)
          setShowProvisioning(false)
        }
        else {
          const fillProviData = fillData.filter((e) => filterDesignation.includes(e.device_type))
          setData(fillProviData)
          setFildataToSearchData(fillProviData)
          setFildataToSearchData(fillProviData)
          setconstantTypes(filterDesignation)
          setShowProvisioning(false)
        }
      }
    } catch (e) {
      console.log("Error in filterModel:", e);
    }
  }

  function locationClosePopup() {
    setFilterSelectedLocations(constantLocation);
  }

  function ApplyfilterModel(selectedmodel, second) {
    try {
      console.log("jstarModels", selectedmodel)
      if (selectedmodel.length > 0 && second != 2) {
        const fillModels = data.filter((e) => selectedmodel.includes(e.properties.model));
        const modelChipData = selectedmodel.map((item, index) => index === 0 ? `Models : ${item}` : item).join(",")
        setData(fillModels);
        setFildataToSearchData(fillModels)
        setShowDeviceTypeModel(!showDeviceTypeModel);
        setconstantfilterModels(selectedmodel)
        setSelectedModelChip(modelChipData)
      }
      if (second == 2) {
        let filterData3 = [...fillData]
        if (constantLocation.length > 0 || constantTypes.length > 0) {
          filterData3 = filterData3.filter((e) => selectedmodel.includes(e.properties.model));
          if (constantLocation.length > 0) {
            filterData3 = filterData3.filter((e) => constantLocation.includes(e.geometry.regionName))
          } if (constantTypes.length > 0) {
            filterData3 = filterData3.filter((e) => constantTypes.includes(e.device_type))
          }
          const modelChipData = selectedmodel.map((item, index) => index === 0 ? `Models : ${item}` : item).join(",")
          setData(filterData3);
          setFildataToSearchData(filterData3)
          setShowDeviceTypeModel(!showDeviceTypeModel);
          setconstantfilterModels(selectedmodel)
          setSelectedModelChip(modelChipData)
        } else {
          const fillModels = fillData.filter((e) => selectedmodel.includes(e.properties.model));
          const modelChipData = selectedmodel.map((item, index) => index === 0 ? `Models : ${item}` : item).join(",")
          setData(fillModels);
          setFildataToSearchData(fillModels)
          setShowDeviceTypeModel(!showDeviceTypeModel);
          setconstantfilterModels(selectedmodel)
          setSelectedModelChip(modelChipData)
        }
      }
    } catch (e) {
      console.log("Error in filterModel:", e);
    }
  }
  async function getLiveApiDataDevicesInfo() {
    try {
      console.log("getLiveApiDataDevicesInfo  node server request :");
      setIsloading(true)
     
      var apirespone = await getLiveDataRegisteredDevicesInDeviceMap(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid, undefined,
        TabIDConstant.ONLINE_DEVICE_MAP_SUBLINK
      );
      console.dir(apirespone);
      if (!apirespone.ok) {
        console.log("Network response was not ok ! there might be some issue exist at api-server");
        setData([]); //sample data to test in local network
        setIsloading(false);
        setTimeout(() => {
        searchRef.current.focus()
        },100)
        // throw new Error('Network response was not ok');
        // setData(datahard);
        // frameMapSearch(datahard);
      }
      else {
        if (apirespone.status == 200) {
          let apidata = await apirespone.json();
          setData(apidata.devices.parkData);
          setFillData(apidata.devices.parkData);
          const locationList = [...new Set(apidata.devices?.parkData?.map(item => item.geometry.regionName))];
          setLocationsList(locationList);
          const deviceModels = [...new Set(apidata.devices?.parkData?.filter((item) => item.properties.model !== "-" && item.properties.model !== "Streams Mobile" && item.properties.model !== "Streams Desktop").map(item => item.properties.model))]
          setDeviceModelsList(deviceModels);
          frameMapSearch(apidata.devices);
          console.log("server response is recieved : " + JSON.stringify(apidata.devices));
          setIsloading(false); //
          setTimeout(() => {
           searchRef.current.focus()
          },100)
          // setData(datahard);
          // frameMapSearch(datahard);
        }
      }
   
      
     
    } catch (e) {
      console.log("Error in getLiveApiDataDevicesInfo :" + e);
    }
  }


  function parseCountry(input) {
    if (!input) return { code: null, name: null };
  
    const raw = input.trim();
    const upper = raw.toUpperCase();
  
    const IGNORE_WORDS = ["the", "of", "and"];
  
    function getFormattedName(alpha2) {
      const fullName = countries.getName(alpha2, "en");
      const words = fullName.split(/\s+/);
  
      if (words.length <= 2) {
        return fullName; // simple names return normal
      }
  
      // Remove filler words
      const filtered = words.filter(
        w => !IGNORE_WORDS.includes(w.toLowerCase())
      );
  
      // Take first letter of each main word
      const shortCode = filtered.map(w => w[0].toUpperCase()).join("");
  
      return shortCode;
    }
  
    // Case 1: Valid 2-letter code
    if (upper.length === 2 && countries.isValid(upper)) {
      return {
        code: upper,
        name: getFormattedName(upper)
      };
    }
  
    // Case 2: Valid 3-letter code
    if (upper.length === 3) {
      const alpha2 = countries.alpha3ToAlpha2(upper);
      if (alpha2) {
        return {
          code: alpha2,
          name: getFormattedName(alpha2)
        };
      }
    }
  
    // Case 3: Country name
    const alpha2FromName = countries.getAlpha2Code(raw, "en");
    if (alpha2FromName) {
      return {
        code: alpha2FromName,
        name: getFormattedName(alpha2FromName)
      };
    }
  
    return { code: null, name: raw };
  }
  
  
  const [currentMarkerOjects, setCurrrentMarkerOjects] = useState([]);
  var markerData = [];
  function getMarkerData(coordinates) {
    try {
      console.log("[getMarkerData] : coordinates: " + JSON.stringify(coordinates));
      var markerPointData = [];

      if (data && data) {
        coordinates.forEach(element => {
          data.forEach(park => {
            if (element.every((ele, index) => ele == park.geometry.coordinates[index])) {
              markerPointData.push(park);
            }
          });
        });
      }

      console.dir(markerPointData);
      setCurrrentMarkerOjects(markerPointData);
      return markerPointData;
    } catch (e) {
      console.error("Error in getMarkerData  :" + e);
    }
  }
  const handleInputChange = (value) => {
    // setInputValue(value);
    handleMapLocationSearch(value); // Your existing logic
  };

  const handletext = (coordinates) => {
    console.dir(coordinates);
    markerData = getMarkerData(coordinates);
    //getNeerest_911_profile(coordinates, markerData);    //Neglecting calculations at UI End 
    return (
      <>
        <div className="mapPopUpBig">
          <div className="p-3">{framepopupHeaders(markerData)}</div>
          <div className="LeafLetPopUpTable">
            <div className="Table">
              
              <MDBTable small>
                <MDBTableHead>
                  <tr>
                    {tableHeaders.map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                  </tr>
                </MDBTableHead>
                <MDBTableBody
                  id="devicestable_content_id"
                  ref={devices_rows}
                  className="mapTable"
                >
                  {markerData.map((element) => (
                    <tr key={element.properties.phonename} id={element.device}>
                      <td>
                        <img src={element.device_type === 4 ? teamsImage :element.device_type === 1 ? phoneImageActive : element.device_type === 2 ?(element.properties?.model?.toLowerCase()?.includes("mac")  ? appleImage : windowsImage ): element.device_type === 3 && element.properties.model?.toLowerCase()?.includes("ios") ? iosImage : androidImage } alt='' />{"  "}
                        {element.properties.phonename}
                      </td>
                      <td>{element.properties.model}</td>
                      <td>{element.properties.mac_address}</td>
                      <td>
                      <p className='fw-normal mb-1'>{element.properties.src_ip} </p>
                      <p className='text-muted mb-0 text-small d-flex align-items-center'><ReactCountryFlag countryCode={parseCountry(element.geometry.country)?.code} svg />  <span className="pl-1">{element.geometry.city.charAt(0).toUpperCase() + element.geometry.city.slice(1).toLowerCase()},{parseCountry(element.geometry.country)?.name}</span></p>
                        </td>
                      <td id={element.device + "_coordinates"}><MDBIcon fas icon="map-marker-alt" /></td>
                    </tr>
                  ))}
                </MDBTableBody>
                
              </MDBTable>
            </div>
            
          </div>
        </div>

        
        
      </>
    )
  }
  const handleClusterClickContent = (coordinates) => {
    console.dir("handleClusterClickContent coordinates " + coordinates);
    markerData = getMarkerData(coordinates);
    return (
      <>
        <div>
          <h5>Device List</h5>
          <MDBTable small>
            <MDBTableHead>
              <tr>
                {tableHeadersNew.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </MDBTableHead>
            <MDBTableBody
              id="devicestable_content_id"
              ref={devices_rows}
              className="mapTable"
            >
              {markerData.map((element) => (
                <tr key={element.properties.phonename} id={element.device}>
                  <td>
                    <div className='d-flex align-items-center'>
                      <img
                        src={ element?.device_type == 4 ? teamsImage : element.device_type === 1 ? phoneImageActive : (element.device_type === 2)?(element.properties?.model?.toLowerCase()?.includes("mac")  ? appleImage : windowsImage ): element.device_type === 3 && element.properties.model?.toLowerCase()?.includes("ios") ? iosImage : androidImage }
                        alt=''
                        style={{ width: '25px', height: '25px' }}
                      />
                      <div className='ms-3'>
                        <p className='fw-bold mb-0'>{element.properties.phonename}</p>
                        <p className='text-muted mb-0 text-small'>{element.properties.model}</p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <p className='fw-normal mb-1'>{element.properties.src_ip} </p>
                    <p className='text-muted mb-0 text-small d-flex align-items-center'><ReactCountryFlag countryCode={parseCountry(element.geometry.country)?.code} svg />  <span className="pl-1">{element.geometry.city.charAt(0).toUpperCase() + element.geometry.city.slice(1).toLowerCase()},{parseCountry(element.geometry.country)?.name}</span></p>

                  </td>
                  <td id={element.device + "_coordinates"}>
                    <MDBIcon fas icon="map-marker-alt" />
                  </td>
                </tr>
              ))}
            </MDBTableBody>
          </MDBTable>
        </div>
      </>
    )
  }


  const framepopupHeaders = (markerData) => {
    //Check for single device header 
    let header_911adress = markerData.find(device => device.device_type * 1 == 1);
    if (header_911adress) {           //Displaying 911_Adress Header
      console.log("[Map][framepopupHeaders] Returned 911_Adress header ");
      return (
        <>
          <div className="d-flex justify-content-start">
            <img src={Location} className="emergencyModal-logo" />
            <div className="px-3 modal-title w-100">
              {t("emergency911Location")}
              <div className="tel-numbers-small">
                {header_911adress.properties.phonename}
              </div>
              <div className="tel-numbers-small">
                {header_911adress.geometry.regionName},{" "}
                {header_911adress.geometry.city} {header_911adress.geometry.zip}
              </div>
            </div>
            
          </div>
          {markerData.length > 1 && (
                <div>
                  <input
                    className="form-control mb-1 mt-3"
                    type="search"
                    placeholder="Search by Name or MAC"
                    value={search}
                    id="popup-input"
                    onChange={(event) => setSearch(event.target.value)}
                  />
                  {/* <MDBIcon fas icon="search" className="mapsearchIcon" /> */}
                </div>)}
        </>
      )
    } else if (markerData.length > 1) {   // returns header for multidevice Location
      console.log("[Map][framepopupHeaders] Returned Multi device Location header ");
      return (
        <>
          <div className="d-flex justify-content-start">
            <img src={Location} className="emergencyModal-logo" />
            <div className="px-3 modal-title w-100">{t("multiDevice")}</div>
          </div>
        </>
      )
    } else if (markerData.length == 1) {
      console.log("[Map][framepopupHeaders] Returned with single device header ");
      return (<>
        <div className="d-flex justify-content-start">
          <img src={markerData[0]?.device_type == 4 ? teamsImage : markerData[0].device_type == 2 ?(markerData[0].properties?.model?.toLowerCase()?.includes("mac")  ? appleImage : windowsImage ): markerData[0].device_type === 3 && markerData[0].properties.model?.toLowerCase()?.includes("ios") ? iosImage : androidImage} className="emergencyModal-logo" />
          <div className="px-3 modal-title w-100">{t("single_device")}</div>
        </div>
      </>)
    }


    //Default case below code will execute 

    return (
      <>
        {markerData.length <= 1 ? (
          <div className="d-flex justify-content-start">
            <img src={Location} className="emergencyModal-logo" />
            <div className="px-3 modal-title w-100">
              {t("emergency911Location")}
              <div className="tel-numbers-small">
                {markerData[0].properties.phonename}
              </div>
              <div className="tel-numbers-small">
                {markerData[0].geometry.regionName},{" "}
                {markerData[0].geometry.city} {markerData[0].geometry.zip}
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-start">
            <img src={Location} className="emergencyModal-logo" />
            <div className="px-3 modal-title w-100">{t("multiDevice")}</div>
          </div>
        )}
      </>
    );

  };

  const prepareRowsdata = () => {
    console.log("in prepareRowsdata");
    // Filter the markerData based on the search term
    const filteredData = currentMarkerOjects.filter(
      (element) =>
        element.properties.phonename
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        element.properties.mac_address
          .toLowerCase()
          .includes(search.toLowerCase())
    );
    console.log("filteredData:::::::::::::");
    console.dir(filteredData);
    const jsxContent = (
      <>
        {
          filteredData.length === 0 ?
            <tr className="text-center">
              <td colSpan={4}>
                No Records Found..
              </td>
            </tr>
            :
            filteredData.map((element) => (
              <tr key={element.properties.phonename} id={element.device}>
                      <td>
                        <img src={element.device_type === 4 ? teamsImage :element.device_type === 1 ? phoneImageActive : element.device_type === 2 ?(element.properties?.model?.toLowerCase()?.includes("mac")  ? appleImage : windowsImage ): element.device_type === 3 && element.properties.model?.toLowerCase()?.includes("ios") ? iosImage : androidImage } alt='' />{"  "}
                        {element.properties.phonename}
                      </td>
                      <td>{element.properties.model}</td>
                      <td>{element.properties.mac_address}</td>
                      <td>
                      <p className='fw-normal mb-1'>{element.properties.src_ip} </p>
                      <p className='text-muted mb-0 text-small d-flex align-items-center'><ReactCountryFlag countryCode={parseCountry(element.geometry.country)?.code} svg />  <span className="pl-1">{element.geometry.city.charAt(0).toUpperCase() + element.geometry.city.slice(1).toLowerCase()},{parseCountry(element.geometry.country)?.name}</span></p>
                        </td>
                      <td id={element.device + "_coordinates"}><MDBIcon fas icon="map-marker-alt" /></td>
                    </tr>
            ))
        }
      </>
    );

    return {
      jsxContent,
      filteredData,
    };
  };

  
  const setSearchValues = (event) => {
    console.log("in setSearchValues" + event.target.value);
    if (event.target) {
      console.log("setting::::::::::::");
      setSearch(event.target.value);
    }
    console.log("searching:  ", search);
  };
  /**
   * Below method will Load Map in div Container
   * Added:16-12-2023 ,Ganesh
   */
  var closePopupTime;
  const clickListeners = []; // Created an array to store the event listener functions
  const [currentGeoCoordinates, setcurrentGeoCoordinates] = useState({});
  var popupRef = useRef(null);
  const loadMap = () => {
    console.log("changed..", data)
    console.log("Request came to load Map ::::");
    const mapNode = document.getElementById("mapId");
    var markerBounds = [];
    if (!mapNode || map.current) {
      // Reset the map if data changes
      map.current.remove();  // Remove the current map instance
    }
    map.current = L.map(mapNode, { minZoom: 3, attributionControl: false, maxBounds: [[-90, -180], [90, 180]] })
    // As per PRD: Make the map black and white
    const tileLayer = L.tileLayer(`https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png/${UIConstant.MAP_API_KEY}`,
      {
        maxZoom: 18,
        noWrap: true
      }
    ).addTo(map.current);
    L.control
      .attribution({
        position: 'bottomright' // Position the attribution at the bottom left
      })
      .addAttribution('©<a href="https://carto.com" target="_blank">CARTO</a> | <a href="https://www.openstreetmap.org/copyright" target="_blank"></a> <strong>Disclaimer:</strong>Some devices may be showing an approximate location.') 
       .addTo(map.current);
      map.current.zoomControl.remove();
    var zoomControl = L.control.zoom({
      position: 'bottomright'
    }).addTo(map.current);


    function markersPointingToSameLocation(array) {
      try {
        const firstObject = JSON.stringify(array[0]._latlng); // Serialize the first object
        return array.every(obj => JSON.stringify(obj._latlng) === firstObject);
      } catch (e) {
        console.log("error :: markersPointingToSameLocation " + e)
      }
      return false;
    }
    let previousZoomLevel = map.current.getZoom();
    map.current.on('zoomend', () => {
      const currentZoomLevel = map.current.getZoom();

      if (currentZoomLevel > previousZoomLevel) {
        // Zoomed in
        if (popupRef?.current) {
          popupRef.current.remove();
          popupRef.current = null
        }
        // Perform operation for zoom in
      } else if (currentZoomLevel < previousZoomLevel) {
        // Zoomed out

        if (popupRef?.current) {
          popupRef.current.remove();
          popupRef.current = null
        }
        // Perform operation for zoom out
      }

      // Update previousZoomLevel for the next zoom event
      previousZoomLevel = currentZoomLevel;
    });

    const clusterLayer = L.markerClusterGroup({
      maxClusterRadius: 40,
      minClusterSize: 1,
      disableClusteringAtZoom: 13,
      spiderfyOnMaxZoom: false,
      showCoverageOnHover: false,
      zoomToBoundsOnClick: false,
      iconCreateFunction: function (cluster) {
        const childMarkers = cluster.getAllChildMarkers();
        const blueMarkers = childMarkers.filter(marker => marker.options.icon.options.className === "blue-tower-icon");
        const redMarkers = childMarkers.filter(marker => marker.options.icon.options.className === "red-tower-icon");
        console.log("markersPointingToSameLocation.......:" + markersPointingToSameLocation(childMarkers));
        if (childMarkers.length > 1 && markersPointingToSameLocation(childMarkers)) {
          return L.divIcon({
            html: `${cluster.getChildCount()}`,
            className: 'blue-tower-icon', iconUrl: TowerIconBlue, html: `<p class="map-marker-badge">${cluster.getChildCount()}</p>`,
            iconSize: [30, 30]
          });
        } else {
          return L.divIcon({
            html: `<div><span style="color: #fff;">${cluster.getChildCount()}</span></div>`,
            className: 'custom-cluster-icon red-cluster',
            iconSize: [30, 30]
          });
        }
      }
    });

    tileLayer.on("load", () => {
      console.log("Map has finished loading!");
      // setIsloading(false); // hiding loader currently displaying in UI
    });

    var mark = [];
    if (data && data.length > 0) {
      let customicon = "";
      const markerArray = [];
      data.forEach((obj, index) => {
        let multi_records = data.filter(item => (
          item.geometry.coordinates[0] == obj.geometry.coordinates[0] &&
          item.geometry.coordinates[1] == obj.geometry.coordinates[1]
        ));

        console.log("multi_records length :" + multi_records.length);

        if (multi_records.length > 1) {
          customicon = L.divIcon({
            className: 'blue-tower-icon', iconUrl: TowerIconBlue, html: `<p class="map-marker-badge">${multi_records.length}</p>`
          });
        } else {
          customicon = L.divIcon({
            className: 'blue-tower-icon', iconUrl: TowerIconBlue, html: `<p class="map-marker-badge">${multi_records.length}</p>`
          });
        }

        const marker = L.marker(obj.geometry.coordinates, { icon: customicon });
        mark.push(marker);
        marker.addTo(clusterLayer);
        markerArray.push(obj.geometry.coordinates);
      });

      map.current.addLayer(clusterLayer);
      // Get bounds of the marker cluster group
      console.log("markerArray :" + JSON.stringify(markerArray));
      markerBounds = L.latLngBounds(markerArray);
      addMouseEvents(clusterLayer);

    }


    setTimeout(() => {
      try {
        map.current.invalidateSize();

        if (Object.entries(markerBounds).length > 0) {
          map.current.fitBounds(markerBounds);
        } else {
          const defaultBounds = [
            [49.38, -66.94], // Northeast corner
            [24.52, -125.00] // Southwest corner
          ];
          map.current.fitBounds(defaultBounds);
          console.log("No markers in map ");
        }

      } catch (e) {
        console.error("Error in fitBounds :" + e);
      }
    }, 300);


  };
  const addMouseEvents = (clusterLayer) => {

    try {

      clusterLayer.on("mouseover", (e) => {   //will use on Marker mouseover 
        console.log("Marker MouseOver called ::::::::::::");
        if (popupRef?.current) {
          popupRef.current.remove();
          popupRef.current = null;
          setTimeout(() => {
            handleClickOnMarker([[e.latlng.lat, e.latlng.lng]], e);
          }, 300)
          clearTimeout(closePopupTime)
        }

        else {
          setTimeout(() => {
            handleClickOnMarker([[e.latlng.lat, e.latlng.lng]], e);
          }, 300)
        }
      });


      clusterLayer.on("mouseout", (e) => {   //will use on Marker for mouse out 
        console.log("Marker MouseLeave Called:::::::::::::");
        if (popupRef?.current?._container) {
          var popupElement = popupRef.current._container;
          console.log("popupRef.current: " + popupRef.current);
          console.dir(popupRef.current);
          console.log("Event....");
          console.dir(e);
          var clusterElement = e.originalEvent.relatedTarget;
          // Check if the mouse is still over the cluster marker or if it has moved to the popup content
          if (!clusterElement || !popupElement.contains(clusterElement)) {
            // Close the popup only if the mouse has left the cluster marker
            closePopupTime = setTimeout(() => {
              if (popupRef.current) {
                popupRef.current.remove();
                popupRef.current = null; // Reset the popup reference
              }
            }, 1000);
          }
        }
      });

      //Will use this event for click on Cluster , it will Zoom map to bounds and set Zoom level 
      clusterLayer.on("clusterclick", function (a) {
        map.current.fitBounds(a.layer.getBounds(), { maxZoom: map.current.getMaxZoom() });
      });



      clusterLayer.on("clustermouseover", function (a) {
        console.log("clustermouseover called:::::::::::::");
        console.log(a.layer.getAllChildMarkers());
        console.dir(a);

        let childCoordinatesSet = new Set();

        a.layer.getAllChildMarkers().forEach(e => {
          let latLng = e.getLatLng();
          let coordStr = `${latLng.lat},${latLng.lng}`;
          childCoordinatesSet.add(coordStr);
        });

        // Convert the Set back to an array of coordinate arrays
        let childCoordinates = Array.from(childCoordinatesSet).map(coordStr => {
          let [lat, lng] = coordStr.split(',').map(Number);
          return [lat, lng];
        });
        if (popupRef?.current) {
          popupRef.current.remove();
          popupRef.current = null;
          setTimeout(() => {
            handleClickOnMarker(childCoordinates, a, true);
          }, 300)
          clearTimeout(closePopupTime)
        }
        else {
          setTimeout(() => {
            handleClickOnMarker(childCoordinates, a, true);
          }, 300)
        }


      });


      clusterLayer.on("clustermouseout", function (a) {
        if (popupRef?.current?._container) {
          var popupElement = popupRef.current._container;
          var clusterElement = a.originalEvent.relatedTarget;
          // Check if the mouse is still over the cluster marker or if it has moved to the popup content
          if (!clusterElement || !popupElement.contains(clusterElement)) {
            closePopupTime = setTimeout(() => {
              // Close the popup only if the mouse has left the cluster marker
              if (popupRef.current) {
                popupRef.current.remove();
                popupRef.current = null; // Reset the popup reference
              }
            }, 1000);
          }
        }
      });

    } catch (e) {
      console.error("Error in while adding MouseEvents to Map clustors and markers : " + e);
    }

  }

  const handleClickOnMarker = (coordinatesAray, e, isClusterClick) => {   // [[12.2342,-89.3425],[13.1234,78.5432]]
    // Handle Marker Click event

    console.log("[handleClickOnMarker] Marker Clicked geo - coordinates : " + JSON.stringify(coordinatesAray) + " latLang " + e.latlng);

    const clickedCoordinates = e.latlng; //Extract Clicked coordinates
    let content1;
    setcurrentGeoCoordinates(e.latlng);
    if (isClusterClick) {
      content1 = handleClusterClickContent(coordinatesAray);
    } else {
      content1 = handletext(coordinatesAray);
    }

    const content = ReactDOMServer.renderToStaticMarkup(content1);
    popupRef.current = L.popup({
      maxWidth: 730, // Set your desired maximum width
    }).setContent(content);

    popupRef.current.setLatLng(clickedCoordinates).openOn(map.current);

    if (popupRef.current) {
      console.log("Popup opened");
      console.dir(markerData);
      if (document.getElementById("popup-input")) {
        const inputElement = document.getElementById("popup-input");
        // Attach a custom event listener for input change on searchbox in case of popup display
        inputElement.addEventListener("input", (event) => {
          setSearchValues(event);

        });
      }

      if (markerData.length > 0) {
        markerData.forEach((element) => {

          const listenerFunction = (e) => {
            console.log("Click operation is performed on:", JSON.stringify(element));
            redirectionToSettings(element);
          };

          //Add the click listener to the element
          document.getElementById(element.device).addEventListener("click", listenerFunction);
          document.getElementById(element.device + "_coordinates").addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log("click operation Location ::::::::::::::::::::::::::::::::::::::::::::::::::::::")
            if (map.current) {
              if (popupRef.current) {
                popupRef.current.remove();
                popupRef.current = null;
              }
              map.current.setView(element.geometry.coordinates, map.current.getMaxZoom());
            }
          })

          // Save the listener function in the array
          clickListeners.push({ element, listenerFunction });
        });
      }
      popupRef.current._container.addEventListener("mouseenter", () => {
        clearTimeout(closePopupTime);
        console.log("Popup hovered.");
      });
      // Add close event to the map when the popup is closed

      map.current.on("popupclose", () => {
        console.log("Popup closed");

        // Remove the click listeners when the popup is closed
        clickListeners.forEach(({ element, listenerFunction }) => {
          if (document.getElementById(element.device)) {
            document.getElementById(element.device).removeEventListener("click", listenerFunction);
          }
        });
        // Clear the array
        clickListeners.length = 0;
      });


      // Add event listener to close the popup when mouse leaves the popup container
      popupRef.current._container.addEventListener('mouseleave', function () {
        // Close the popup when the mouse leaves the popup container

        if (popupRef.current && document.querySelector("#popup-input")?.value === "" || document.querySelector("#popup-input")?.value === undefined) {
          // Reset the popup reference

          popupRef.current.remove();
          popupRef.current = null;
        }


      });

    }
  };
  // const location = useLocation();

  const redirectionToSettings = function (data) {
    if (data.provisioning_type * 1 == 1) {
      console.log("data.properties.mac_address " + data.properties.mac_address);
      data.properties.mac_address = data.properties.mac_address;
      window.open(`/ipphoneadd?mac_address=${data.properties.mac_address}`);
    }else if (data.provisioning_type * 1 == 3) {
      console.log("data.properties.mac_address " + data.properties.mac_address);
      data.properties.mac_address = data.properties.mac_address;
      window.open(`/YealinkSettings?mac_address=${data.properties.mac_address}`);
    }
     else if (data.provisioning_type * 1 == 2) {
      console.log("Manual device  ::  " + data.device)
      window.open(`/manualdevicesettings?device=${data.device}`);
    } else {
      console.log("Alert...!! No settings page for mobiles and desktops ");
    }
  };


  /*
  * Currently we are not using below method 
  * In Future if we need will use :Ganesh
  */

  const getNeerest_911_profile = (clickedCoordinates, markerdata) => {
    let nearestDistance = Infinity;
    let nearestProfile = null;
    let distance;
    console.log(
      "getNeerest_911_profile center cordinates: " + clickedCoordinates
    );
    markerdata.forEach((item) => {
      if (item.geometry.coordinates_911) {
        distance = getDistanceBetweenPoints(
          clickedCoordinates[0],
          clickedCoordinates[1],
          item.geometry.coordinates_911[0],
          item.geometry.coordinates_911[1]
        );
        console.log("calculated distance for objects:" + distance);
      }
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestProfile = item;
      }
    });

    console.log("Nearest 911 profile:", nearestProfile);
    console.log("Distance to nearest profile:", nearestDistance);
  };



  /*
  * Currently we are not using below method 
  * In Future if we need will use :Ganesh
  */
  function getDistanceBetweenPoints(latitude1, longitude1, latitude2, longitude2, unit = "miles") {
    let theta = longitude1 - longitude2;
    let distance =
      60 *
      1.1515 *
      (180 / Math.PI) *
      Math.acos(
        Math.sin(latitude1 * (Math.PI / 180)) *
        Math.sin(latitude2 * (Math.PI / 180)) +
        Math.cos(latitude1 * (Math.PI / 180)) *
        Math.cos(latitude2 * (Math.PI / 180)) *
        Math.cos(theta * (Math.PI / 180))
      );
    if (unit == "miles") {
      return Math.round(distance, 2);
    } else if (unit == "kilometers") {
      return Math.round(distance * 1.609344, 2);
    }
  }


  useEffect(() => {
    getLiveApiDataDevicesInfo();
  }, []);

  useEffect(() => {
    if (data != null) {
      // setTimeout(() => {
      console.log("Map is loading :::::::::::");
      loadMap();
      // }, 1000);
    }
    console.log("data Changeddd...")

  }, [data]);

  useEffect(() => {
    if (popupRef.current) {
      console.log("re-render with search ");
      const filterContent = prepareRowsdata(); //handletext([currentGeoCoordinates.lat, currentGeoCoordinates.lng]);
      const reactElement = ReactDOMServer.renderToString(filterContent.jsxContent);
      // devices_rows.current.innerHTML = reactElement;
      document.getElementById("devicestable_content_id").innerHTML =
        reactElement;

      if (filterContent.filteredData.length > 0) {
        filterContent.filteredData.forEach((element) => {
          const listenerFunction = (e) => {

            console.log("Click operation is performed on:", JSON.stringify(element));
            redirectionToSettings(element);
          };
          console.log("Adding listeners for search data " + element.device);
          //Add the click listener to the element
          document.getElementById(element.device).addEventListener("click", listenerFunction);

          // Save the listener function in the array
          clickListeners.push({ element, listenerFunction });
        });
      }
      // popupRef.current.setContent(ReactDOMServer.renderToStaticMarkup(filterContent));
    }
  }, [search]);



  function frameMapSearch(devices) {
    console.log("frameMapSearch::::::");
    let markobjects = [];

    devices.parkData.forEach(item => {
      console.dir(item);
      let macInfo = "";
      if (item.device_type * 1 == 2 || item.device_type * 1 == 3) {
        macInfo = item.properties.model
      } else {
        macInfo = item.properties.mac_address;
      }
      markobjects.push({ label: item.properties.phonename, mac: macInfo, value: item.device, coordinates: item.geometry.coordinates });
    })
    console.log("markobjects :" + JSON.stringify(markobjects));
    const uniqueMarkObjects = markobjects?.filter((value, index, self) => {
      return index == self?.findIndex((data) => (
        data.label == value.label
      ));
    });
    setSearchData(uniqueMarkObjects);
  }


  const setFildataToSearchData=(data)=>{
    let markobjects=[]
    data.forEach(item => {
      console.dir(item);
      let macInfo = "";
      if (item.device_type * 1 == 2 || item.device_type * 1 == 3) {
        macInfo = item.properties.model
      } else {
        macInfo = item.properties.mac_address;
      }
      markobjects.push({ label: item.properties.phonename, mac: macInfo, value: item.device, coordinates: item.geometry.coordinates });
    })
    console.log("markobjects :" + JSON.stringify(markobjects));
    const uniqueMarkObjects = markobjects?.filter((value, index, self) => {
      return index == self?.findIndex((data) => (
        data.label == value.label
      ));
    });
    setSearchData(uniqueMarkObjects);
  }



  const [selectedOption, setSelectedOption] = useState(null);
  const [data1, setData1] = useState();
  const handleMapLocationSearch = (inputValue) => {
    console.log("Searching for:", inputValue);
    if (inputValue) {
      setData1(inputValue);
      setSelectedOption([{ label: data1, value: "", mac: "" }]);
    }
  };

  const handleChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setSelectedOption(selectedOption);

    if (selectedOption) {
      map.current.setView(selectedOption.coordinates, map.current.getMaxZoom());
    } else {
      setInputValue(""); // ⬅ clear the text inside Select
      map.current.setView([0, 0], 0);
    }
  };


  const closeSearch = (e) => {
    console.log("Menu closed" + data1);
    setData1(data1);
  }
  const closePopup = () => {
    setShowAddDevicePopup(false);
  };

  const normalize = (val) => (val || "").toLowerCase();

const normalizeMac = (val) =>
  (val || "").toLowerCase().replace(/[:\-\s]/g, "");

const customFilter = (option, inputValue) => {
  if (!inputValue) return true;

  const search = normalize(inputValue);
  const mac = normalizeMac(option?.data?.mac);
  const rawMac = normalize(option?.data?.mac);
  const label = normalize(option?.data?.label);

  //  MAC search only if meaningful hex present
  const isMacSearch =
    /^[0-9a-f:-]+$/i.test(search) && /[0-9a-f]{2}/i.test(search);

  if (isMacSearch) {
    return (
      mac.includes(normalizeMac(search)) || // normalized
      rawMac.includes(search)               // with : or -
    );
  }

  //  normal search (handles -, (), text etc.)
  return label.includes(search) || rawMac.includes(search);
};

  return (
    <>
      <div className="mapSearch d-flex" >
        <div className="searchFilter">
          <div>
            <Select
              options={searchData}
              // onInputChange={(inputValue) => handleMapLocationSearch(inputValue)}
              value={selectedOption}
              onChange={handleChange}
              // inputValue={inputValue}
              // onInputChange={handleInputChange}
              isClearable
              isSearchable
              filterOption={customFilter}
              getOptionLabel={(option) => option.mac ? `${option.label} (${option.mac})` : option.label}
              getOptionValue={(option) => option?.value}
              placeholder="Search..."
              styles={{ border: "none" }}
              // onMenuClose={(e) => closeSearch(e)}
              classNamePrefix="react-select"
              ref={searchRef}
            />
          </div>

          <div className="ms-3" style={{ display: "flex" }}>
            <div>
              {selectedLocationchips != "" && (
                <div className="me-3 popconfirmFilter">
                  <MDBPopconfirm onClose={() => locationClosePopup()} className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                    <MDBChip closeIcon className="m-0" onClick={(e) => { e.preventDefault(); }} onDelete={(e) => handleDelete(1, filterSelectedLocations)}>
                      <div className="filterElliipse">
                        {selectedLocationchips}
                      </div>
                    </MDBChip>
                  </>}
                  >
                    <MDBPopconfirmMessage>
                      <div className="d-flex flex-column mt-2 cursor-pointer">
                        <div
                          className={`d-flex flex-column ${filterSelectedLocations.length > 0 ? 'Filter_disabled' : ''}`}
                          onClick={filterSelectedLocations.length > 0 ? null : toggleLocation}>
                          Location
                        </div>
                        {locationsList && locationsList.map((location) => (
                          <div key={location}>
                            <MDBCheckbox
                              name='flexCheck3'
                              value={location}
                              id={`flexCheckLocation_${location}`}
                              label={location}
                              checked={filterSelectedLocations.includes(location)}
                              onChange={() => handleFilterLocations(location)}
                            />
                          </div>
                        ))}

                      </div>

                      {/* {constantLocation.length > 0 &&( */}
                      <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                        {showLocation && filterSelectedLocations.length > 0 && !isArraysEqual(filterSelectedLocations, constantLocation) && (
                          <div>
                            <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(4)}>Cancel</MDBBtn>
                            <MDBBtn size="sm" className="ms-2" onClick={(e) => filterLocations(e, filterSelectedLocations, 2)}> Apply</MDBBtn>
                          </div>
                        )}
                      </MDBModalFooter>
                      {/* )} */}
                    </MDBPopconfirmMessage>
                  </MDBPopconfirm>

                </div>

              )}
              {provisioningTypeChips != "" && (
                <div className="me-3 popconfirmFilter">
                  <MDBPopconfirm onClose={() => typesClosePopup()} className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                    <MDBChip closeIcon className="m-0" onClick={(e) => { e.preventDefault(); }} onDelete={(e) => handleDelete(2, provisioningTypes)}>
                      <div className="filterElliipse">
                        {provisioningTypeChips}
                      </div>
                    </MDBChip>
                  </>}
                  >
                    <MDBPopconfirmMessage>
                      <div className="d-flex flex-column mt-2 cursor-pointer">

                        <div
                          className={`d-flex flex-column ${provisioningTypes.length > 0 ? 'Filter_disabled' : ''}`}
                          onClick={provisioningTypes.length > 0 ? null : toggleProvisioning}>
                          Device Type
                        </div>

                        <div>
                          <div>
                            <MDBCheckbox name='flexCheck4' value='' id='flexCheckProvisioning1' label='Desktop' checked={provisioningTypes ? provisioningTypes.includes(2) : null} onChange={() => handleProvisioningDevise(2)} />
                          </div>
                          <div className="mt-2">
                            <MDBCheckbox name='flexCheck4' value='' id='flexCheckProvisioning2' label='IP Phones' checked={provisioningTypes ? provisioningTypes.includes(1) : null} onChange={() => handleProvisioningDevise(1)} />
                          </div>
                          <div className="mt-2">
                            <MDBCheckbox name='flexCheck4' value='' id='flexCheckProvisioning3' label='Mobile' checked={provisioningTypes ? provisioningTypes.includes(3) : null} onChange={() => handleProvisioningDevise(3)} />
                          </div>
                        </div>
                      </div>
                      {constantTypes && showProvisioning && (
                        <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                          {provisioningTypes.length > 0 && !isArraysEqual(provisioningTypes, constantTypes) && (
                            <div>
                              <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(5)}>Cancel</MDBBtn>
                              <MDBBtn size="sm" className="ms-2" onClick={(e) => handleProvisioningChange(provisioningTypes, 2)}> Apply</MDBBtn>
                            </div>
                          )}
                        </MDBModalFooter>
                      )}
                    </MDBPopconfirmMessage>

                  </MDBPopconfirm>


                </div>

              )}
              {selectedModelChip != "" && (
                <div className="me-3 popconfirmFilter">
                  <MDBPopconfirm onClose={() => modelsClosePopup()} className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                    <MDBChip closeIcon className="m-0" onClick={(e) => { e.preventDefault(); }} onDelete={(e) => handleDelete(3, filterModels)}>
                      <div className="filterElliipse">
                        {selectedModelChip}
                      </div>
                    </MDBChip>
                  </>}>
                    <MDBPopconfirmMessage>
                      <div className="d-flex flex-column mt-2 cursor-pointer">
                        <div>
                          Device Type & Model
                        </div>
                        {deviceModelsList && deviceModelsList
                          .map(Model => (
                            <div key={Model}>
                              <MDBCheckbox
                                name='flexCheck3'
                                value={Model}
                                id={`flexCheckLocation_${Model}`}
                                label={Model}
                                checked={filterModels?.includes(Model)}
                                onChange={(e) => selectFilterModel(Model)}
                              />
                            </div>
                          ))}
                      </div>

                      {constantfilterModels && showDeviceTypeModel && (
                        <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                          {filterModels.length > 0 && !isArraysEqual(filterModels, constantfilterModels) && (
                            <div>
                              <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(6)}>Cancel</MDBBtn>
                              <MDBBtn size="sm" className="ms-2" onClick={(e) => ApplyfilterModel(filterModels, 2)}> Apply</MDBBtn>
                            </div>
                          )}
                        </MDBModalFooter>
                      )}
                    </MDBPopconfirmMessage>
                  </MDBPopconfirm>

                </div>

              )}
            </div>
            <MDBPopconfirm onClose={(e) => firstClose(e)} placement="bottom-start" btnChildren={(<>  <MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}</>)}>
              <MDBPopconfirmMessage>
                <div>
                  <p className='mb-3 fw-600 filterhead'>
                    {showLocation || showProvisioning || showDeviceTypeModel
                      ? (showLocation ? "Location"
                        : showProvisioning ? "Device Type"
                          : showDeviceTypeModel ? "Model"
                            : "")
                      : "Filter by"}
                  </p>
                  {!showLocation && !showProvisioning && !showDeviceTypeModel && (
                    <>
                      <div className="d-flex flex-column mt-2 cursor-pointer">
                        <div
                          className={`d-flex flex-column ${filterSelectedLocations.length > 0 ? 'Filter_disabled' : ''}`}
                          onClick={filterSelectedLocations?.length > 0 ? null : toggleLocation}
                        >
                          Location
                        </div>
                      </div>
                      <div className="d-flex flex-column mt-2 cursor-pointer">
                        {/* <div className="cursor-pointer" onClick={toggleProvisioning}>Provisioning Type</div> */}
                        <div
                          className={`d-flex flex-column ${provisioningTypes.length > 0 ? 'Filter_disabled' : ''}`}
                          onClick={provisioningTypes.length > 0 ? null : toggleProvisioning}>
                          Device Type
                        </div>
                      </div>
                      <div className="d-flex flex-column mt-2 cursor-pointer">
                        <div
                          className={`d-flex flex-column ${filterModels.length > 0 ? 'Filter_disabled' : ''}`}
                          onClick={filterModels.length > 0 ? null : toggleDeviceTypeModel}>
                          Model
                        </div>
                      </div>
                      {/* <div className="d-flex flex-column mt-2">
                        <div className="cursor-pointer" onClick={toggleAllBubble}>ALL Devices</div>
                      </div> */}
                    </>
                  )}
                  {showLocation && locationsList?.map((location, index) => (
                    <div key={`${location}_${index}`}>
                      <MDBCheckbox
                        name='flexCheck3'
                        value={location}
                        id={`flexCheckLocation_${location}`}
                        label={location}
                        onChange={() => handleFilterLocations(location)}
                      />
                    </div>
                  ))}
                  {showProvisioning && (
                    <div>
                      <div className="mt-2">
                        <MDBCheckbox name='flexCheck4' value='' id='flexCheckProvisioning3' label='Mobile' onChange={() => handleProvisioningDevise(3)} />
                      </div>
                      <div>
                        <MDBCheckbox name='flexCheck4' value='' id='flexCheckProvisioning1' label='Desktop' onChange={() => handleProvisioningDevise(2)} />
                      </div>
                      <div className="mt-2">
                        <MDBCheckbox name='flexCheck4' value='' id='flexCheckProvisioning2' label='IP Phones' onChange={() => handleProvisioningDevise(1)} />
                      </div>

                    </div>
                  )}
                  {showDeviceTypeModel && deviceModelsList?.map(Model => (
                    <div key={Model}>
                      <MDBCheckbox
                        name='flexCheck3'
                        value={Model}
                        id={`flexCheckLocation_${Model}`}
                        label={Model}
                        onChange={() => selectFilterModel(Model)}
                      />
                    </div>
                  ))}
                </div>
                {showLocation && (
                  <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                    <MDBBtn size='sm' outline color='secondary' onClick={(e) => toggleBackClick(e, 1)} className="mx-0">Back</MDBBtn>
                    {filterSelectedLocations.length > 0 && (
                      <div>
                        <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(1)}>Cancel</MDBBtn>
                        <MDBBtn size="sm" className="ms-2" onClick={(e) => filterLocations(e, filterSelectedLocations)} > Apply</MDBBtn>
                      </div>
                    )}
                  </MDBModalFooter>
                )}
                {showProvisioning ? (
                  <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                    <MDBBtn size='sm' outline color='secondary' onClick={(e) => toggleBackClick(e, 2)} className="mx-0">Back</MDBBtn>
                    {provisioningTypes.length > 0 && (
                      <div>
                        <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(2)}>Cancel</MDBBtn>
                        <MDBBtn size="sm" className="ms-2" onClick={(e) => handleProvisioningChange(provisioningTypes)} > Apply</MDBBtn>
                      </div>
                    )}
                  </MDBModalFooter>
                ) : null}
                {showDeviceTypeModel && (
                  <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                    <MDBBtn size='sm' outline color='secondary' onClick={(e) => toggleBackClick(e, 3)} className="mx-0">Back</MDBBtn>
                    {filterModels.length > 0 && (
                      <div>
                        <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(3)}>Cancel</MDBBtn>
                        <MDBBtn size="sm" className="ms-2" onClick={(e) => ApplyfilterModel(filterModels)}> Apply</MDBBtn>
                      </div>
                    )}
                  </MDBModalFooter>
                )}
              </MDBPopconfirmMessage>
            </MDBPopconfirm>
            {(selectedModelChip !== "" || selectedLocationchips !== "" || provisioningTypeChips !== "") && (
              <MDBBtn className="mx-2" onClick={(e) => clearFilterData(true)} >Clear</MDBBtn>
            )}

          </div>
        </div>
        <div className="ms-3" >
          <MDBBtn size="lg" className="h-100 px-4 fs-6"
            onClick={addDeviceToggle}>
            <MDBIcon fas icon="plus" className="pe-2" />
            {t("Add Device")}
          </MDBBtn>
        </div>
      </div>
      <div
        style={{ width: "100%", height: "calc(100vh - 280px)" }}
        id="mapId"
      >
      </div>
      {isloading && (
        <div>
          <div className="loadingclass-popup"></div>
          <div className="popup-bg-loader loader_align">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </div>
      )}
      {showAddDevicePopup && (
        <ShowAddDevicePopup
          reuseDeviceInfo={""}
          unassigndeviceList={""}
          onClosePopup={closePopup}
          showDevicePopup={setShowAddDevicePopup}
        />
      )}
    </>
  );
}

function ShowAddDevicePopup(props) {
  return (
    <>
      <PopupLoader
        title={"Add Device"}
        content={<AddDevices replaceDeviceInfo={props.reuseDeviceInfo} unassigndeviceList={props.unassigndeviceList} onClose={(e) => props.onClosePopup()} />}
        onShow={props.showDevicePopup}
        onClose={props.onClosePopup}
      />
    </>
  );
}
export default Map;
